module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAdCAMAAACKeiw+AAAAM1BMVEX////////////////////////////////////////////////////////////////////lEOhHAAAAEHRSTlMAECAwQFBgcICQoLDA0ODwVOCoyAAAAQVJREFUGBltwQlihCAQRcEHtD2ILP/+p40RYpxMqviV9jokteKBD97VdjezfGiUwJvUVCJL8D5ePPhoiYewq3BzFf7YRmFJo/AhaWfqlX+4jG95RBbL2QPL0TmFkVmqTiMxRTngCkxZl85SKnAcLFVTZNoUYDhL1WQsMpAxxa7JIlPLmAKXQ7cRuNSMiSkeWroz1YwpMpmWwlIzyLjErh/O1F/QX5zCPvSrJE5BBqVxil0PY+PkAjZFvpluO5daOPXC4k3qOTCZjJPL+BGNW6tcag982kfkEkYL/OVyljRa5F2Wc0ttOA+xynkIu7oHJitqiXexSHXPOdeh5nwKW66n/RW5fQHT2A7WpPKYEQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/001-snapchat.png
// module id = 204
// module chunks = 4